import i18n from "i18next";
import { TabItem } from "components/Tabs";

export enum TabsValue {
  INFO = 0,
  USAGE_REPORT = 1,
}
export const tabsData: TabItem<TabsValue>[] = [
  {
    label: i18n.t("info"),
    value: TabsValue.INFO,
  },
  {
    label: i18n.t("usageReport"),
    value: TabsValue.USAGE_REPORT,
  },
];
